import React from 'react';
import { Link } from 'react-router-dom';
import SentimentDisclaimer from '../ui/SentimentDisclaimer';
import AppName from '../ui/AppName';

const Footer: React.FC = () => {
  return (
    <footer
      className="footer-shell flex-shrink-0 py-4 sm:py-6 pb-[max(1rem,env(safe-area-inset-bottom))] sm:pb-[max(1.5rem,env(safe-area-inset-bottom))] border-t border-brand-border mt-auto relative z-10"
    >
      <div className="container">
        <div className="flex flex-col md:flex-row justify-between items-center gap-2 sm:gap-4 mb-2 sm:mb-4">
          <div className="flex flex-col items-center md:items-start gap-0.5 sm:gap-1">
            <AppName className="text-base sm:text-lg font-bold" />
            <span className="text-[10px] sm:text-xs text-white/40 tracking-wider uppercase">© 2026. All rights reserved.</span>
          </div>
          
          <nav className="flex flex-wrap justify-center sm:justify-start gap-3 sm:gap-4 md:gap-6">
            <Link to="/terms" className="text-xs sm:text-sm text-white/60 hover:text-brand-cyan transition-colors no-underline">Terms</Link>
            <Link to="/privacy" className="text-xs sm:text-sm text-white/60 hover:text-brand-cyan transition-colors no-underline">Privacy</Link>
            <Link to="/risk-disclosure" className="text-xs sm:text-sm text-white/60 hover:text-brand-cyan transition-colors no-underline">Risk Disclosure</Link>
          </nav>

          <div className="flex flex-wrap justify-center sm:justify-start gap-3 sm:gap-4 md:gap-6">
            <a href="https://t.me/sentihype" target="_blank" rel="noopener noreferrer" className="text-xs sm:text-sm text-white/60 hover:text-brand-cyan transition-colors no-underline">Telegram</a>
            <a href="mailto:info@sentihype.com" className="text-xs sm:text-sm text-white/60 hover:text-brand-cyan transition-colors no-underline">info@sentihype.com</a>
          </div>
        </div>
        <SentimentDisclaimer variant="compact" className="text-center mt-0" />
      </div>
    </footer>
  );
};

export default Footer; 
